import { render, staticRenderFns } from "./ChatterDrawer.vue?vue&type=template&id=4a95983a"
import script from "./ChatterDrawer.vue?vue&type=script&lang=js"
export * from "./ChatterDrawer.vue?vue&type=script&lang=js"
import style0 from "./ChatterDrawer.vue?vue&type=style&index=0&id=4a95983a&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports